import { render, staticRenderFns } from "./ListMarcas.vue?vue&type=template&id=617310d5"
import script from "./ListMarcas.vue?vue&type=script&lang=js"
export * from "./ListMarcas.vue?vue&type=script&lang=js"
import style0 from "./ListMarcas.vue?vue&type=style&index=0&id=617310d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports